import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DateControl, firstNestedSymbolControl} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {NgForm} from '@angular/forms';
import {UiUpdateService} from '../../../services/ui-update.service';
import {ISymbol, MomentService} from '@lv1871/core';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {EventService} from '../../../services/event.service';
import {StageConfigService} from '../../../services/stage-config.service';
import {tap} from 'rxjs';
import {FondsService} from '../../../services/fonds.service';

@Component({
    selector: 'lv-date-toolbox',
    templateUrl: './date-toolbox.component.html',
    styleUrls: ['./date-toolbox.component.scss'],
    standalone: false
})
export class DateToolboxComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public model;
  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public autocomplete: string;

  private _uiArtefakt: DateControl;

  constructor(private cd: ChangeDetectorRef, private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService, private _eventService: EventService,
              private _uiUpdateService: UiUpdateService, private _momentService: MomentService,
              private _fondsService: FondsService, private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): DateControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: DateControl) {
    this._uiArtefakt = uiArtefakt;
    const newDate = this._momentService.moment(this.uiArtefakt.WertEingabe, 'YYYY-MM-DD', true)?.toDate();
    if (JSON.stringify(newDate) !== JSON.stringify(this.model)) {
      this.model = newDate;
    }
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
    this.nestedSymbol = firstNestedSymbolControl(this._uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this._uiArtefakt, this._ngForm);
    if (this._uiArtefakt.FeldnameRisikopruefung?.indexOf('versicherungsbeginn') >= 0 &&
        !!this._uiArtefakt.WertEingabe) {
      this._eventService.versicherungsbeginn$.next(this._uiArtefakt.WertEingabe);
      this._fondsService.fetchFondsgruppenUndFonds$.subscribe();
    }
  }

  public ngAfterViewInit() {
    this.cd.detectChanges();
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public changeDate(value: Date) {
    if (value === null) {
      return;
    }
    this.model = value;
    const newdate = this._momentService.moment(value).format('YYYY-MM-DD');
    if (newdate === this.uiArtefakt.WertEingabe) {
      return;
    }
    this.uiArtefakt.WertEingabe = newdate;
    if (this._uiArtefakt.FeldnameRisikopruefung?.indexOf('versicherungsbeginn') >= 0 &&
        !!this._uiArtefakt.WertEingabe) {
      this._eventService.versicherungsbeginn$.next(this._uiArtefakt.WertEingabe);
      this._fondsService.fetchFondsgruppenUndFonds$.pipe(
          tap(_ => this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt))
      ).subscribe();
    } else {
      this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt);
    }
  }

  onBlur($event: any) {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

}
